import React from 'react';
import { formatBlogDate, getBlogDateTime } from '../lib/featured.js';

export default function BlogByline({ date, author }) {
  const formatted = formatBlogDate(date);
  const dateTime = getBlogDateTime(date);

  if (!formatted && !author) return null;

  return (
    <p className="dev-blog-byline">
      {formatted && (
        <time dateTime={dateTime || undefined}>{formatted}</time>
      )}
      {formatted && author && <span aria-hidden="true"> · </span>}
      {author && <span className="dev-blog-author">{author}</span>}
    </p>
  );
}
